module.exports = __webpack_public_path__ + "img/40_38_034_540.f3ebf7c3.jpg";